(function () {
  const root = document.querySelector('[data-sh-product-finder]');
  if (!root) return;

  const configUrl = root.getAttribute('data-config-url');
  const stepsContainer = root.querySelector('[data-finder-steps]');
  const resultsContainer = root.querySelector('[data-finder-results]');
  const backBtn = root.querySelector('[data-finder-back]');
  const restartBtn = root.querySelector('[data-finder-restart]');

  let config = null;
  let stepIndex = 0;
  const answers = {};

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(cents / 100);
  }

  function formatProductPrice(product) {
    const availableVariants = product.variants.filter((variant) => variant.available);
    const prices = (availableVariants.length ? availableVariants : product.variants).map(
      (variant) => variant.price
    );
    if (!prices.length) return null;
    const min = Math.min(...prices);
    const max = Math.max(...prices);
    if (min !== max) return `From ${formatMoney(min)}`;
    return formatMoney(min);
  }

  function reasonForHandle(handle, resultKey) {
    const reasons = config.handleReasons || {};
    if (reasons[handle]) return reasons[handle];
    const byResult = config.resultReasons || {};
    if (byResult[resultKey]) return byResult[resultKey];
    return config.defaultReason || 'Matches the need and setting you selected.';
  }

  function resultsHeading(count) {
    const copy = config.resultCopy || {};
    if (count === 1) {
      return copy.headingOne || copy.heading || 'Here’s a strong match to explore';
    }
    return copy.headingMany || copy.heading || 'Here are ideas that fit your answers';
  }

  function renderStep() {
    const step = config.steps[stepIndex];
    stepsContainer.innerHTML = '';
    resultsContainer.hidden = true;
    stepsContainer.hidden = false;
    backBtn.hidden = stepIndex === 0;
    restartBtn.hidden = true;

    const stepEl = document.createElement('div');
    stepEl.className = 'sh-product-finder__step is-active';
    stepEl.innerHTML = `
      <h2 class="h2">${step.question}</h2>
      <div class="sh-product-finder__options" role="list"></div>
    `;

    const optionsEl = stepEl.querySelector('.sh-product-finder__options');
    step.options.forEach((option) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sh-product-finder__option';
      button.setAttribute('data-option-id', option.id);
      button.innerHTML = `
        <span class="sh-product-finder__option-title">${option.label}</span>
        <span>${option.description}</span>
      `;
      button.addEventListener('click', () => selectOption(step.id, option.id, button));
      optionsEl.appendChild(button);
    });

    stepsContainer.appendChild(stepEl);
  }

  function selectOption(stepId, optionId, button) {
    answers[stepId] = optionId;
    button
      .closest('.sh-product-finder__options')
      .querySelectorAll('.sh-product-finder__option')
      .forEach((el) => el.classList.remove('is-selected'));
    button.classList.add('is-selected');

    window.setTimeout(() => {
      if (stepIndex < config.steps.length - 1) {
        stepIndex += 1;
        renderStep();
      } else {
        showResults();
      }
    }, 180);
  }

  async function fetchProduct(handle) {
    const response = await fetch(`/products/${handle}.js`);
    if (!response.ok) throw new Error(`Product not found: ${handle}`);
    return response.json();
  }

  async function showResults() {
    const key = `${answers.need}:${answers.place}`;
    const handles = config.results[key] || [];
    const copy = config.resultCopy || {};
    const intro =
      copy.intro ||
      'Suggestions based on your answers — not medical advice. Tap a product for sizes, stock, and full details.';
    const maxResults = Number(config.maxResults) > 0 ? Number(config.maxResults) : 5;

    stepsContainer.hidden = true;
    resultsContainer.hidden = false;
    backBtn.hidden = true;
    restartBtn.hidden = false;

    resultsContainer.innerHTML = `
      <h2 class="h2" data-results-heading>Finding matches…</h2>
      <p>${intro}</p>
      <div class="sh-product-finder__results" data-results-grid></div>
    `;

    const headingEl = resultsContainer.querySelector('[data-results-heading]');
    const grid = resultsContainer.querySelector('[data-results-grid]');
    const candidateHandles = [...handles];
    if (config.fallbackResults?.[key]) {
      candidateHandles.push(...config.fallbackResults[key]);
    }

    const seen = new Set();
    let shown = 0;
    for (const handle of candidateHandles) {
      if (shown >= maxResults) break;
      if (seen.has(handle)) continue;
      seen.add(handle);
      try {
        const product = await fetchProduct(handle);
        if (!product.available) continue;

        const priceLabel = formatProductPrice(product);
        if (!priceLabel) continue;

        const reason = reasonForHandle(handle, key);
        const card = document.createElement('a');
        card.className = 'sh-product-finder__result-card';
        card.href = product.url;
        card.innerHTML = `
          <img src="${product.featured_image}" alt="${product.title}" loading="lazy" width="400" height="400">
          <div class="sh-product-finder__result-body">
            <strong>${product.title}</strong>
            <p class="sh-product-finder__result-price">${priceLabel}</p>
            <p class="sh-product-finder__result-reason">${reason}</p>
          </div>
        `;
        grid.appendChild(card);
        shown += 1;
      } catch (error) {
        console.warn(error);
      }
    }

    if (!grid.children.length) {
      headingEl.textContent = 'No strong matches right now';
      grid.innerHTML =
        '<p>We could not find in-stock matches for that combination right now. Please <a href="/pages/contact">contact us</a> and we will help you choose.</p>';
      return;
    }

    headingEl.textContent = resultsHeading(grid.children.length);
  }

  function restart() {
    stepIndex = 0;
    Object.keys(answers).forEach((key) => delete answers[key]);
    renderStep();
  }

  backBtn?.addEventListener('click', () => {
    if (stepIndex > 0) {
      stepIndex -= 1;
      renderStep();
    }
  });

  restartBtn?.addEventListener('click', restart);

  fetch(configUrl)
    .then((response) => response.json())
    .then((data) => {
      config = data;
      renderStep();
    })
    .catch(() => {
      stepsContainer.innerHTML =
        '<p>Sorry, the product finder could not load. Please try again later or <a href="/pages/contact">contact us</a>.</p>';
    });
})();
